import type { Role } from "@/lib/users.api";
import { useUserStats } from "@/hooks/queries/useUserStats";
import { useUsers } from "@/hooks/queries/useUsers";

export function useUsersPageData(filters: { search: string; roleFilter: Role | "" }) {
  const { data, isLoading } = useUsers(filters);
  const { data: stats, isLoading: statsLoading } = useUserStats();

  return {
    users: data?.data ?? [],
    total: data?.total ?? 0,
    stats,
    isLoading,
    statsLoading,
  };
}
